import { GlofoxSidebarNav } from "@/components/portal/GlofoxSidebarNav";

export function GlofoxSidebar() {
  return (
    <aside
      className="sidebar"
      style={{ background: "var(--abc)" }}
      aria-label="Documentation"
      data-testid="gf-sidebar"
    >
      <GlofoxSidebarNav />
    </aside>
  );
}
